<template>
  <div class="page_footer">
    <div class="vue_flex">
      <div>关于</div>
      <div>
        <div class='vue_flex button'>
          <el-button type="text" @click="gobrief()" :disabled='isClickable'>公司介绍</el-button>
          <el-button type="text" @click="goOur()" :disabled='!isClickable'>联系我们</el-button>
          <!-- <div @click="gobrief()">
              <p>公司介绍</p>
          </div>
          <div style="margin-left:20px;" @click="goOur()">
              <p>联系我们</p>
          </div> -->
        </div>
      </div>
    </div>

    <!-- 横线 -->
    <el-divider></el-divider>

    <div class='image'>
      <img src='../assets/word.png'/>
    </div>  
    <!-- <div class="hao">备案号：闽ICP备2020016439号</div> -->
    <div class="hao">
      <a href="https://beian.miit.gov.cn/" target="_blank">备案号：闽ICP备2023000601号</a>
    </div>
  </div>
</template>

<script>
// 导入bus的模块对象
import bus from '@/utils/bus.js';
export default {
  data() {
    return {
      isClickable: true,// 根据条件来决定是否可以点击
    }
  },
  methods:{
    // 跳转到该路径
    gobrief(){
      this.isClickable = true;
      this.$router.push({path:"/mobile"});
    },
    goOur() {
      this.isClickable = false;
      this.$router.push({path:"/mobile/connect"});
    },
  },
  mounted() {
    // console.log(this.$route.path,'this.$route.path')
    // 判断当前的路径
    this.isClickable = this.$route.path == '/mobile/' || this.$route.path == '/mobile'? true : false;
  },
  // 接收兄弟传值
  created() {
    // 实例对象.$on(事件名称,function(形参,形参){}事件事件的回调方法)
    // 注意：回调函数变为箭头函数，使得this可以正确使用
    bus.$on('jieshou', msg => {
      // 判断上面菜单变化
      this.isClickable = msg == '/mobile/' || this.$route.path == '/mobile' ? true : false;
    });
  },
}
</script>

<style scoped lang="scss">
.page_footer{
  background-color: #EFEFEF;
  width: 100%;
  font-size:14px;
  padding: 20px 20px 40px;
  box-sizing: border-box;
}
.el-divider--horizontal {
  margin: 15px 0;
}
.image{
  padding: 20px 0 10px;
  width: 260px;
  margin: auto;
  height: 26px;
  img{
    width: 100%;
    height: 100%;
  }
}
.hao{
  text-align: center;
}
</style>

<style scoped>
.button .el-button{
  padding:0;
}
/* .button .el-button--text{
  color: #3953DA;
} */
.el-button--text{
  color: #606266;
}
.el-button.is-disabled, .el-button.is-disabled:focus, .el-button.is-disabled:hover {
    color: #3953DA;
}
</style>

